const styles = theme => ({
  formControl: {
    width: '100%',
    margin: "5px 0"
  },
  blockWrapper: {
    maxWidth: 500,
    marginBottom: 30
  },
  controls: {
    [theme.breakpoints.down('md')]: {
      marginBottom: 20
    },
    marginTop: 20,
    textAlign: "center"
  },
  radioLabelBody: {
    width: '100%'
  }
});

export default styles;
